"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _underscore = _interopRequireDefault(require("underscore"));
var _single_dropdown = _interopRequireDefault(require("./single_dropdown"));
var _index = require("./index");
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SimpleSingleDropdown = function SimpleSingleDropdown(props) {
  var items = props.items,
    selectedItem = props.selectedItem,
    onSelectedItemChange = props.onSelectedItemChange,
    error = props.error,
    disabled = props.disabled,
    helperText = props.helperText,
    placeholder = props.placeholder,
    clearable = props.clearable,
    readOnly = props.readOnly,
    required = props.required;
  var wrappedSelectedItemChanged = function wrappedSelectedItemChanged(event) {
    return onSelectedItemChange && onSelectedItemChange(event.selectedItem);
  };
  var dropdownProps = (0, _index.useSingleDropdown)({
    items: items,
    selectedItem: selectedItem,
    onSelectedItemChange: wrappedSelectedItemChanged
  });

  // TODO: Find a better solution for picking the labelProps off of props without having to cast them - https://greenhouseio.atlassian.net/browse/GREEN-40416
  // We need to provide the labelProps as a spread object for the types to work properly
  var labelProps = _underscore["default"].pick(props, 'label', 'ariaLabel', 'ariaLabelledBy');
  return /*#__PURE__*/React.createElement(_single_dropdown["default"], null, /*#__PURE__*/React.createElement(_single_dropdown["default"].Field, (0, _extends2["default"])({
    dropdownProps: dropdownProps,
    error: error,
    disabled: disabled,
    helperText: helperText,
    placeholder: placeholder,
    clearable: clearable,
    readOnly: readOnly,
    required: required
  }, labelProps, (0, _constants.getDataProvidesProps)(props, function (dataProvidesString) {
    return "".concat(dataProvidesString, "-field");
  }))), /*#__PURE__*/React.createElement(_single_dropdown["default"].Flyout, (0, _extends2["default"])({
    dropdownProps: dropdownProps
  }, (0, _constants.getDataProvidesProps)(props, function (dataProvidesString) {
    return "".concat(dataProvidesString, "-flyout");
  }))));
};
var _default = SimpleSingleDropdown;
exports["default"] = _default;